export const color = {
  primary: window.color.searchBoxBgColor || "#107295",
  secondary: window.color.buttonColor || "#E62C5F",
  couponBackground: window.color.offerBoxBgColor || "#FCFBB7",
  white: "#FFF",
  alto: "#ddd",
  green: "#1eb24b",
  greenlike: "#52bb9b",
  male: "#0295d2",
  female: "#EC1287",
  grey: "#ababab",
  greydark: "#757575",
  chekColor: '#01AEF0',
  borderRadius: "6px",
  blue: "#01AEF0",
  activeInput: "#004f9e",

};

export const apiUrl = {
  // GET ? fromCityID | toCityID | fromCityName | toCityName | journeyDate | mode
  search: "/api/resource/searchRoutesV4",
  // GET ? tripId | chartDate | fromCity | toCity
  track: "/api/others/GetGPSLocationURL",
  // GET ? routeID
  routeInfo: "/api/resource/getRouteInfo",
  // GET ? routeID | journeyDate
  chart: "/api/resource/seatArrangement",
  // POST
  orderSave: "/api/expco/ordersave",
  // GET ? token
  orderDetails: "/api/expco/getOrderDetails",
  // GET ? RouteCode | SeatLabel_ | Gender_
  genderValidate: "/api/resource/APIGenderValidate",
  // GET ? RouteCode | MobileNumber | EmailID | CouponName
  couponList: "/api/resource/APICouponCardListAll",
  // GET ? RouteCode | MobileNumber | Email | CouponName | OpDiscount | TotalFare | CouponName2 | CouponName3 | IsLoggedin | ServiceCharge | Stax
  //couponRedeem: "/api/resource/APIRedeemCouponv4",
  couponRedeem: "/api/resource/APIRedeemCouponv5",
  // GET ? RouteCode | MobileNumber | OTP | CouponName | OpDiscount | TotalFare | CouponName2 | CouponName3 | ServiceCharge | Stax
  couponValidate: "/api/resource/APIvalidateCouponOTPV4",
  // GET ? mobile | prepaid_no
  prepaidDetails: "/api/others/prepaid_card_details",
  // POST
  prepaidSave: "/api/expco/prepaidCardOrderSave",
  // GET ? mobile | otptype=PD
  generateOTP: "/api/resource/GenerateOTP",
  // GET ? OTP | otptype=PD
  validateOTP: "/api/resource/APIValidateAgentOTPLogin",
  saveProfile: "/my_profile/saveProfile",
  // GET ? | citylist
  getcities: "/api/resource/getCities",
  //GET ? RouteCode
  middlecities: "/api/resource/ActiveMiddleCities",
  //GET ? agent_id or msurl  any of them
  ismantispg: "/api/resource/ismantispg",
  //GET ? mobile_number , siteurl if needed
  getlogintoken: "/api/resource/APIGetlogintoken",
  // GET ? fromCityId 
  getPickStations: "/api/resource/getPickupsByCity",
  // GET ? toCityId 
  getDropStaions: "/api/resource/getDropOffsByCity",
  getLinkCity: "/api/resource/GetLinkedCitiesPair",
  //GET ? tripId , chartDate
  tripSummaryPKpDrp: "/api/resource/APIMSTripsSummaryPkpDrp",

  // GET ? fromCityID | toCityID | journeyDate
  searchPkpDrp: '/api/resource/searchRoutesPkpDrp',
  getStaticCity: '/api/resource/getStaticCityList',
  getCityList: '/api/resource/getCityList',
  getLeavyAndConcession: '/api/resource/getConcessionAndLevy',
  checkoutLogin: '/api/resource/checkoutLogin',
  //Get
  SendSignupOtp: "/api/resource/SendSignupOtp",
  //POST
  APISignup: "/api/resource/APISignup",
  //POST
  userLogin: "/api/resource/userLogin",
  //GET
  userPwdOtp: "/api/resource/userPwdOtp",
  //POST
  userResetPwd: "/api/resource/userResetPwd",
  //GET
  getUserDetails: "/api/resource/getUserDetailsV1",
  //POSt
  editUserDetails: "/api/resource/editUserDetailsV1",

  //POSt
  editUserMobile: "/api/resource/editUserMobile",

  bookingInfo: "/api/resource/BookingInfo",
  //GET
  cancelConfirm: "/api/ticket/cancelConfirm",
  //GET
  calculateCancellationCharges: '/api/resource/calculateCancellationCharges',
  //POST
  pnrCancelRequest: "/api/resource/pnrCancelRequest",
  //GET
  editBooking: '/api/resource/editBooking',
  //GET
  getTimeTable: '/api/resource/getTimeTable',
  //GET
  getcountryCode: '/api/resource/countryCode',
  getBookingByUserId: '/api/resource/getBookingByUserId',
  //GET
  sendBookingTicket: '/api/resource/sendBookingTicket',

  //GET
  validateTxnPwd: '/api/resource/validateTxnPwd',

  // POST
  deleteProfile: '/api/resource/deleteProfile',

  // POST ? userName | password
  checkoutLogin: "/api/resource/checkoutLogin",
  getTxnPwd: "/api/resource/getTxnPwd",
  genQrImg: "/api/resource/genQrImg",
  getBranchOrder: '/api/expco/getBranchOrderDetails',
  validateCaptcha: '/api/resource/validateCaptcha',
  getBusImage: '/api/resource/getBusImage',
  validPnr: '/api/resource/validPnr',
  updateTxnPwd: '/api/resource/updateTxnPwd',

  //FEED BACK 
  getFeedbackDetsByPnr: "/api/resource/getFeedbackDetsByPnr", // GET
  submitFeedback: "/api/resource/submitFeedback", // Post
  getFeedbackDets: "/api/resource/getFeedbackDets", // GET

  getMobNo: '/api/resource/getMobileNoFromPnr',

  //CMS
  getReservationTermsContent: '/api/resource/getReservationTermsContent',
  getGuestUsersTermsContent: '/api/resource/getGuestUsersTermsContent', 
  getRefundRulesAndClaimsContent: '/api/resource/getRefundRulesAndClaimsContent', 
  getToken: '/api/resource/getToken',
  generateOTPV2: "/api/resource/generateOTPV2",
  validateOTPV2: "/api/resource/validateOTPV2",
  markFavourite: "/api/resource/markFavourite",

  getTourPackageData: "/api/resource/getTourPackageData",
};

export const idCardTypes = [
  {
    name: 'PAN',
  },
  {
    name: 'AADHAR',
  }
];

export const nationalityData = [
  {
    name: 'Indian',
  }
];

export const countryCodeData = [
  {
    name: 'India +91',
    id: '+91',
  }
];

export const genderTypeData = [
  {
    name: 'Male',
    svg: 'male-icon',
    color: '#0086FF',
  },
  {
    name: 'Female',
    svg: 'female-icon',
    color: '#EC1287',
  },
  {
    name: 'Others',
    svg: 'others-icon',
    color: '#444444',
  },
];

export const idCardData = ['PAN', 'AADHAR', 'Driving License', 'Voter ID', 'Passport', 'Ration Card', 'Senior citizen ID', 'Govt. ID', 'Company ID', 'Educational ID'];

// export const nationality = [
//   "Afghanistan",
//   "Albania",
//   "Algeria",
//   "Andorra",
//   "Angola",
//   "Antigua and Barbuda",
//   "Argentina",
//   "Armenia",
//   "Australia",
//   "Austria",
//   "Azerbaijan",
//   "Bahamas",
//   "Bahrain",
//   "Bangladesh",
//   "Barbados",
//   "Belarus",
//   "Belgium",
//   "Belize",
//   "Benin",
//   "Bhutan",
//   "Bolivia",
//   "Bosnia and Herzegovina",
//   "Botswana",
//   "Brazil",
//   "Brunei",
//   "Bulgaria",
//   "Burkina Faso",
//   "Burundi",
//   "Cabo Verde",
//   "Cambodia",
//   "Cameroon",
//   "Canada",
//   "Central African Republic",
//   "Chad",
//   "Chile",
//   "China",
//   "Colombia",
//   "Comoros",
//   "Congo",
//   "Costa Rica",
//   "Croatia",
//   "Cuba",
//   "Cyprus",
//   "Czech Republic",
//   "Denmark",
//   "Djibouti",
//   "Dominica",
//   "Dominican Republic",
//   "Ecuador",
//   "Egypt",
//   "El Salvador",
//   "Equatorial Guinea",
//   "Eritrea",
//   "Estonia",
//   "Eswatini",
//   "Ethiopia",
//   "Fiji",
//   "Finland",
//   "France",
//   "Gabon",
//   "Gambia",
//   "Georgia",
//   "Germany",
//   "Ghana",
//   "Greece",
//   "Grenada",
//   "Guatemala",
//   "Guinea",
//   "Guinea-Bissau",
//   "Guyana",
//   "Haiti",
//   "Honduras",
//   "Hungary",
//   "Iceland",
//   "India",
//   "Indonesia",
//   "Iran",
//   "Iraq",
//   "Ireland",
//   "Israel",
//   "Italy",
//   "Jamaica",
//   "Japan",
//   "Jordan",
//   "Kazakhstan",
//   "Kenya",
//   "Kiribati",
//   "Kuwait",
//   "Kyrgyzstan",
//   "Laos",
//   "Latvia",
//   "Lebanon",
//   "Lesotho",
//   "Liberia",
//   "Libya",
//   "Liechtenstein",
//   "Lithuania",
//   "Luxembourg",
//   "Madagascar",
//   "Malawi",
//   "Malaysia",
//   "Maldives",
//   "Mali",
//   "Malta",
//   "Marshall Islands",
//   "Mauritania",
//   "Mauritius",
//   "Mexico",
//   "Micronesia",
//   "Moldova",
//   "Monaco",
//   "Mongolia",
//   "Montenegro",
//   "Morocco",
//   "Mozambique",
//   "Myanmar",
//   "Namibia",
//   "Nauru",
//   "Nepal",
//   "Netherlands",
//   "New Zealand",
//   "Nicaragua",
//   "Niger",
//   "Nigeria",
//   "North Korea",
//   "North Macedonia",
//   "Norway",
//   "Oman",
//   "Pakistan",
//   "Palau",
//   "Palestine",
//   "Panama",
//   "Papua New Guinea",
//   "Paraguay",
//   "Peru",
//   "Philippines",
//   "Poland",
//   "Portugal",
//   "Qatar",
//   "Romania",
//   "Russia",
//   "Rwanda",
//   "Saint Kitts and Nevis",
//   "Saint Lucia",
//   "Saint Vincent and the Grenadines",
//   "Samoa",
//   "San Marino",
//   "Sao Tome and Principe",
//   "Saudi Arabia",
//   "Senegal",
//   "Serbia",
//   "Seychelles",
//   "Sierra Leone",
//   "Singapore",
//   "Slovakia",
//   "Slovenia",
//   "Solomon Islands",
//   "Somalia",
//   "South Africa",
//   "South Korea",
//   "South Sudan",
//   "Spain",
//   "Sri Lanka",
//   "Sudan",
//   "Suriname",
//   "Sweden",
//   "Switzerland",
//   "Syria",
//   "Taiwan",
//   "Tajikistan",
//   "Tanzania",
//   "Thailand",
//   "Timor-Leste",
//   "Togo",
//   "Tonga",
//   "Trinidad and Tobago",
//   "Tunisia",
//   "Turkey",
//   "Turkmenistan",
//   "Tuvalu",
//   "Uganda",
//   "Ukraine",
//   "United Arab Emirates",
//   "United Kingdom",
//   "United States of America",
//   "Uruguay",
//   "Uzbekistan",
//   "Vanuatu",
//   "Vatican City",
//   "Venezuela",
//   "Vietnam",
//   "Yemen",
//   "Zambia",
//   "Zimbabwe"
// ];

export const nationality = [
  "India",
  "Myanmar",
  "South Sudan",
  "Republic of the Congo",
  "Democratic Republic of the Congo",
  "The Sudan",
  "Rwanda",
  "Ethiopia",
  "Somalia",
  "Djibouti",
  "Kenya",
  "Tanzania",
  "Uganda",
  "Malawi",
  "Burundi",
  "Saudi Arabia",
  "Afghanistan",
  "Albania",
  "Algeria",
  "American Samoa",
  "Andorra",
  "Angola",
  "Anguilla",
  "Antarctica",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Aruba",
  "Ascension Island",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bermuda",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "Brazil",
  "British Virgin Islands",
  "Brunei",
  "Bulgaria",
  "Burkina Faso",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Cape Verde",
  "Cayman Islands",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Christmas Island",
  "Cocos (Keeling) Islands",
  "Colombia",
  "Comoros",
  "Congo",
  "Cook Islands",
  "Costa Rica",
  "Croatia",
  "Cuba",
  "Cyprus",
  "Czech Republic",
  "Denmark",
  "Diego Garcia",
  "Dominica",
  "Dominican Republic",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Falkland Islands",
  "Faroe Islands",
  "Fiji",
  "Finland",
  "France",
  "French Guiana",
  "French Polynesia",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Gibraltar",
  "Greece",
  "Greenland",
  "Grenada",
  "Guadeloupe",
  "Guam",
  "Guatemala",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Holy See (Vatican City)",
  "Honduras",
  "Hong Kong",
  "Hungary",
  "Iceland",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Isle of Man",
  "Israel",
  "Italy",
  "Ivory Coast",
  "Jamaica",
  "Japan",
  "Jersey",
  "Jordan",
  "Kazakhstan",
  "Kiribati",
  "Kuwait",
  "Kyrgyzstan",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Macau",
  "Macedonia",
  "Madagascar",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Martinique",
  "Mauritania",
  "Mauritius",
  "Mayotte",
  "Mexico",
  "Micronesia",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Montserrat",
  "Morocco",
  "Mozambique",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "Netherlands Antilles",
  "New Caledonia",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "Niue",
  "Norfolk Island",
  "North Korea",
  "Northern Mariana Islands",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Palestine",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Pitcairn Islands",
  "Portugal",
  "Puerto Rico",
  "Qatar",
  "Reunion Island",
  "Romania",
  "Russia",
  "Saint Barthelemy",
  "Saint Helena",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Martin",
  "Saint Pierre and Miquelon",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Sint Maarten",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "South Africa",
  "South Korea",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Svalbard",
  "Swaziland",
  "Sweden",
  "Switzerland",
  "Syria",
  "Taiwan",
  "Tajikistan",
  "Thailand",
  "Timor-Leste (East Timor)",
  "Togo",
  "Tokelau",
  "Tonga Islands",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Turks and Caicos Islands",
  "Tuvalu",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States",
  "Uruguay",
  "US Virgin Islands",
  "Uzbekistan",
  "Vanuatu",
  "Venezuela",
  "Vietnam",
  "Wallis and Futuna",
  "Western Sahara",
  "Yemen",
  "Zambia",
  "Zimbabwe"
];


//  export const captcha_key = '6LfSoNIpAAAAAGanjTxKRls_ssoq8mbC_Dmnb5KA';
//  export const secret_key = '6LfSoNIpAAAAAMQGeTU80tLQ9_O665FwkBIEi1Kv';

export const captcha_key = '6LdDLvcpAAAAACSHq52XvCI-j_ppfOeYIcsKgf_r';
export const secret_key = '6LdDLvcpAAAAAOOcOP5MUCNEleyeD3wqypWOw7Xm';

export const FLYBUSDISC = 8.69;
